<app-health-bar *ngIf="playerService.health > 0"></app-health-bar>
<app-wanted-level></app-wanted-level>
<app-loading-screen *ngIf="UIManagerService.isDisplayed"></app-loading-screen>
<app-target *ngIf="UIManagerService.isPlayerIsAiming"></app-target>
<app-weapon-wheel *ngIf="UIManagerService.isWeaponWheelDisplayed"></app-weapon-wheel>
<app-wasted-overlay></app-wasted-overlay>
<app-rule-of-thirds></app-rule-of-thirds>
